// extracted by mini-css-extract-plugin
module.exports = {"container":"Divider_container__3Utnw","title":"Divider_title__16Jzq","horizontalLine":"Divider_horizontalLine__2aVa-","count":"Divider_count__2ySNE"};